import { createAsyncThunk } from "@reduxjs/toolkit";
import { STATION_DEVICES } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getStationDevicesListAPI: any = createAsyncThunk(
  "getStationDeviceList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(STATION_DEVICES, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: params,
      });
      return { stationDevice: res };
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
